import { ErrorHandler } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';
import { LoggerService } from './app/core/services/logger.service';
import { GlobalErrorHandler } from './app/core/services/global-error-handler';
import { OpenTelemetryService } from './app/core/services/open-telemetry.service';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    // 1. Initialise structured logging (must be first)
    const logger = appRef.injector.get(LoggerService);
    logger.init();
    logger.info('Bootstrap', 'Angular application bootstrapped successfully');

    // 2. Initialise OpenTelemetry distributed tracing
    //    This wires up W3C trace context propagation and ships spans to Tempo.
    const otel = appRef.injector.get(OpenTelemetryService);
    otel.init();

    // 3. Initialise global error listeners (unhandledrejection, window.onerror)
    //    GlobalErrorHandler is provided via ErrorHandler token, so inject via token
    const errorHandler = appRef.injector.get(ErrorHandler) as GlobalErrorHandler;
    errorHandler.init();

    // 4. Flush logs & spans on page unload
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', () => {
        logger.flush();
        otel.shutdown();
      });
    }
  })
  .catch((err) => {
    console.error('Bootstrap failed:', err);
  });
